import clsx from 'clsx'
import PropTypes from 'prop-types'
export default function MainContainer({ children, className }) {
  return (
    <div className={'mx-auto max-w-7xl px-4 py-16'}>
      {/* We've used 3xl here, but feel free to try other max-widths based on your needs */}
      <div className={clsx('mx-auto max-w-4xl', className)}>{children}</div>
    </div>
  )
}

MainContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}
